import { render } from "./editCommission.vue?vue&type=template&id=29f30c34&scoped=true"
import script from "./editCommission.vue?vue&type=script&lang=js"
export * from "./editCommission.vue?vue&type=script&lang=js"

import "./editCommission.vue?vue&type=style&index=0&id=29f30c34&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f30c34"]])

export default __exports__